import { action, createRequestTypes } from '@/utils/actions.utils'
import { projectService } from '@/services'
import { uiActions } from '@/redux/actions'
import { ERROR_403_PATH } from '@/constants'
import Toggles from '@domain/toggles/Toggles'

export const GET_PROJECT_BUDGET = createRequestTypes('GET_PROJECT_BUDGET')
const getProject = ({ projectId, lang, withPrices = false, hotUpdate = false }) => {

	return async (dispatch) => {
		try {
			await dispatch(request({ projectId, hotUpdate }))
			
			let res
			if(Toggles.isEnabled("getProjectWithoutLanguageToBudget")) {
				res = await projectService.getProjectToBudgetV2({ projectId, lang, withPrices })
			} else {
				res = await projectService.getProjectv2({ projectId, lang, withPrices })	
			}

			return dispatch(success(res.data))
		} catch (error) {
			if (error?.response?.status === 403) {
				dispatch(uiActions.navigateTo({ path: ERROR_403_PATH }))
			}

			return dispatch(failure(error))
		}
	}
	function request(payload) {
		return action(GET_PROJECT_BUDGET.REQUEST, payload)
	}
	function success(payload) {
		return action(GET_PROJECT_BUDGET.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_PROJECT_BUDGET.FAILURE, null, err, false)
	}
}

export const GET_PREVIOUS_BUDGETS = createRequestTypes('GET_PREVIOUS_BUDGETS')
const getPreviousBudgets = ({ projectId, lang, hotUpdate = false }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId, hotUpdate }))

			const res = await projectService.getPreviousBudgets({ projectId, lang })
			return dispatch(
				success({
					projectId,
					list: res.data
				})
			)
		} catch (error) {
			return dispatch(failure(error))
		}
	}
	function request(payload) {
		return action(GET_PREVIOUS_BUDGETS.REQUEST, payload)
	}
	function success(payload) {
		return action(GET_PREVIOUS_BUDGETS.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_PREVIOUS_BUDGETS.FAILURE, null, err)
	}
}

export const CHECK_PREVIOUS_BUDGET_ITEM = createRequestTypes('CHECK_PREVIOUS_BUDGET_ITEM')
const checkPreviousBudgetItem = (isChecked, id) => {
	return (dispatch) => {
		return dispatch(success({ isChecked, id }))
	}
	function success(payload) {
		return action(CHECK_PREVIOUS_BUDGET_ITEM.SUCCESS, payload)
	}
}

export const CLEAR_GENERATE_BUDGET = 'CLEAR_GENERATE_BUDGET'
const clearGenerateBudget = () => {
	return action(CLEAR_GENERATE_BUDGET)
}

export const GET_PROJECT_BUDGET_DELETE = createRequestTypes('GET_PROJECT_BUDGET_DELETE')
const deleteProductBudget = ({ productId }) => {
	return (dispatch) => {
		return dispatch(success(productId))
	}
	function success(payload) {
		return action(GET_PROJECT_BUDGET_DELETE.SUCCESS, payload)
	}
}

export const CREATE_BUDGET = createRequestTypes('CREATE_BUDGET')
const createBudget = ({ budgetDetails, formData, history, onlySave = false }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.createBudget({
				budgetDetails,
				formData
			})

			if (onlySave) {
				history.goBack()
			}
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}
	function request() {
		return action(CREATE_BUDGET.REQUEST)
	}
	function success(payload) {
		return action(CREATE_BUDGET.SUCCESS, payload)
	}
	function failure(err) {
		return action(CREATE_BUDGET.FAILURE, err, err, false)
	}
}
export const CREATE_BUDGET_USA = createRequestTypes('CREATE_BUDGET_USA')
const createBudgetUsa = ({ budgetDetails, formData, history, isFinalQuote, onlySave = false }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.createBudgetUsa({
				budgetDetails,
				formData,
				isFinalQuote
			})
			if (onlySave) {
				history.goBack()
			}
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}
	function request() {
		return action(CREATE_BUDGET_USA.REQUEST)
	}
	function success(payload) {
		return action(CREATE_BUDGET_USA.SUCCESS, payload)
	}
	function failure(err) {
		return action(CREATE_BUDGET_USA.FAILURE, err, err, false)
	}
}

export const UPDATE_PRODUCT_QTY_BUDGET = createRequestTypes('UPDATE_PRODUCT_QTY_BUDGET')
const updateProductQuantityBudget = ({ projectId, productId, quantity }) => {
	return (dispatch) => {
		return dispatch(success({ projectId, productId, quantity }))
	}

	function success(payload) {
		return action(UPDATE_PRODUCT_QTY_BUDGET.SUCCESS, payload)
	}
}

export const UPDATE_PRODUCT_DISCOUNT_BUDGET = createRequestTypes('UPDATE_PRODUCT_DISCOUNT_BUDGET')
const updateProductDiscountBudget = ({ projectId, productId, discount }) => {
	return (dispatch) => {
		return dispatch(success({ projectId, productId, discount }))
	}
	function success(payload) {
		return action(UPDATE_PRODUCT_DISCOUNT_BUDGET.SUCCESS, payload)
	}
}

export const UPDATE_DISCOUNT_BUDGET_FOOTER = createRequestTypes('UPDATE_PRODUCT_DISCOUNT_BUDGET_FOOTER')
const updateDiscountBudgetFooter = ({ discount }) => {
	return (dispatch) => {
		return dispatch(success({ discount }))
	}
	function success(payload) {
		return action(UPDATE_DISCOUNT_BUDGET_FOOTER.SUCCESS, payload)
	}
}

export const UPDATE_SURCHARGE_BUDGET_FOOTER = createRequestTypes('UPDATE_SURCHARGE_BUDGET_FOOTER')
const updateSurchargeBudgetFooter = ({ surcharge }) => {
	return (dispatch) => {
		return dispatch(success({ surcharge }))
	}
	function success(payload) {
		return action(UPDATE_SURCHARGE_BUDGET_FOOTER.SUCCESS, payload)
	}
}

export const UPDATE_IVA_BUDGET_FOOTER = createRequestTypes('UPDATE_IVA_BUDGET_FOOTER')
const updateIvaBudgetFooter = ({ iva }) => {
	return (dispatch) => {
		return dispatch(success({ iva }))
	}
	function success(payload) {
		return action(UPDATE_IVA_BUDGET_FOOTER.SUCCESS, payload)
	}
}

export const UPDATE_COMMENT_BUDGET = createRequestTypes('UPDATE_COMMENT_BUDGET')
const updateCommentBudget = ({ comment }) => {
	return (dispatch) => {
		return dispatch(success({ comment }))
	}
	function success(payload) {
		return action(UPDATE_COMMENT_BUDGET.SUCCESS, payload)
	}
}

export const CALCULATE_TOTALS_BUDGET = createRequestTypes('CALCULATE_TOTALS_BUDGET')

const calculateTotalsBudget = () => {
	return (dispatch) => {
		return dispatch(success())
	}

	function success(payload) {
		return action(CALCULATE_TOTALS_BUDGET.SUCCESS, payload)
	}
}
const budgetActions = {
	getProject,
	deleteProductBudget,
	updateProductQuantityBudget,
	updateProductDiscountBudget,
	createBudget,
	createBudgetUsa,
	calculateTotalsBudget,
	updateDiscountBudgetFooter,
	updateSurchargeBudgetFooter,
	updateIvaBudgetFooter,
	updateCommentBudget,
	clearGenerateBudget,
	getPreviousBudgets,
	checkPreviousBudgetItem
}

export default budgetActions
